<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container multiple">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12">
              <div class="row pt-2 pt-lg-0 white" v-if="cursos != null">
                <div class="col-12 pb-3 fXG text-center" v-if="curso.completo == 1">
                  ¡Felicidades
                  <span class="naranja">{{this.$store.state.user.nombre}}</span>!
                </div>
                <div class="col-12 pt-5 pb-5 fG text-center" v-if="curso.completo == 1">
                  Obtuviste {{this.correctas}} de {{this.cursos[index].quiz.length}} respuestas correctas, demostrando que eres un experto en
                  <span
                    class="naranja"
                  >{{curso.titulo}}</span>.
                </div>

                <div class="col-12 pt-5 pb-5 fG text-center" v-if="curso.completo == 0">
                  Obtuviste {{this.correctas}} de {{this.cursos[index].quiz.length}} respuestas correctas, te invitamos a repasar el curso
                  <span
                    class="naranja"
                  >{{curso.titulo}}</span>.
                </div>

                <div class="col-12 fG">
                  <div class="row text-center pb-5">
                    <div class="col-12">
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/cursos/flama_on.png"
                        alt="Badge"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pb-5 objetivo">
                <div class="col-12 col-lg-8 offset-lg-2">
                  <div class="row">
                    <div class="col-12 pt-4">
                      <div class="row">
                        <!-- 
                        <div class="col-12 text-center pb-5">
                          <router-link class="btn btnazul" to="/cursos/avance">Descargar como PDF</router-link>
                        </div>
                        -->

                        <div class="col-12 text-center pb-3">
                          <router-link class="btn btnsup pl-4" to="/cursos/avance">
                            CONTINUAR
                            <i class="fa fa-arrow-alt-circle-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Footer from "../../Components/Footer.vue";
import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);

//Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      curso: null,
      index: -1,
      paso: -1,
      quiz: null,
      respuestas: [],
      correctas: 0,
      division: 0
    };
  },
  mounted: function() {
    // Opción múltiple
    // relacionar columnas
    // eliminar el incorrecto
    // poner en orden varios elementos

    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );
    AOS.init();
    this.cursos = this.$store.state.cursos;
    this.index = this.$route.params.id;
    this.curso = this.cursos[this.index];

    //alert(this.correcta);

    console.log(this.cursos);
    this.contarAciertos();
    console.log('calif');
    this.division = this.correctas / this.cursos[this.index].quiz.length;
    console.log(this.division);
    if (this.division >= 0.5) {
      this.curso.completo = 1;
    } else {
      this.curso.completo = 0;
    }

    this.guardarResultado();
  },
  components: {
    "header-mx": Header,
    "footer-mx":Footer
  },
  methods: {
    guardarResultado() {
      console.log("submit");
      var vm = this;

      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        email: this.$store.state.user.email,
        id_curso: this.cursos[this.index].id,
        nombre_curso:
          this.cursos[this.index].clase + ": " + this.cursos[this.index].titulo,
        calificacion:
          this.correctas + "/" + this.cursos[this.index].quiz.length,
        correctas: this.correctas,
        total_preguntas: this.cursos[this.index].quiz.length,
        img_badge:
          "https://www.sitiossl.com.mx/superama/maestros-de-la-parrilla/admin/flama_on.png",
        obtuvo_badge: this.curso.completo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "quiz.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //guardado, algo más?
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    contarAciertos() {
      var cont = 0;
      this.curso.evaluacion.forEach(element => {
        if (element == 1) {
          cont++;
        }
      });
      this.correctas = cont;
    },
    selecciona(id) {
      console.log(id);
      this.quiz.opciones.forEach(element => {
        if (element.id == id) {
          element.seleccionada = !element.seleccionada;
          if (element.seleccionada == true) {
            this.agregaRespuesta(element.id);
          } else {
            this.eliminaRespuesta(element.id);
          }
        }
      });
    },
    agregaRespuesta(id) {
      console.log("agregando");
      var flag = false;
      var index = -1;
      for (var i = 0; i < this.respuestas.length; i++) {
        if (this.respuestas[i] == id) {
          flag = true;
          index = i;
        }
      }

      if (!flag) {
        this.respuestas.splice(index, 0, id);
        this.respuestas = this.respuestas.sort();
      }

      console.log(flag);
      console.log(this.respuestas);
    },
    eliminaRespuesta(id) {
      console.log("eliminando");
      var flag = false;
      var index = -1;
      for (var i = 0; i < this.respuestas.length; i++) {
        if (this.respuestas[i] == id) {
          flag = true;
          index = i;
        }
      }

      if (flag) {
        this.respuestas.splice(index, 1);
        this.respuestas = this.respuestas.sort();
      }

      console.log(flag);
      console.log(this.respuestas);
    },
    continuar() {
      if (this.respuestas.length > 0) {
        //evaluacion
        var evaluacion = 1;

        if (this.correcta.length == this.respuestas.length) {
          //evaluar respuestas
          for (var i = 0; i < this.correcta.length; i++) {
            if (this.correcta[i] != this.respuestas[i]) {
              evaluacion = 0;
            }
          }
        } else {
          //esta mal
          evaluacion = 0;
        }

        //alert(evaluacion);

        this.cursos[this.index].evaluacion[this.paso] = evaluacion;

        //avanzar
        this.paso++;
        this.cursos[this.index].index_quiz = this.paso;
        this.$router.push("/cursos/badge/" + this.cursos[this.index].id);
      } else {
        swal.fire(
          "Oops",
          "Elimina una opción antes de continuar...",
          "warning"
        );
      }
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        matricula: this.matricula,
        password: this.password
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "home/login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //localStorage.setItem('user', res.user);
              this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              vm.$store.state.user = this.$cookie.get("useracademiadigital");
              this.$router.push(res.url);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

